import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
`;

export const Icon = styled.img`
    width: 40px;
    height: 40px;
`;

export const Label = styled.span`
    font-size: 1rem;
    color: black;
`;